import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatCamelcase' })
export class FormatCamelcasePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;

    return value
      .toLowerCase()
      .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) =>
        index === 0 ? match.toLowerCase() : match.toUpperCase(),
      )
      .replace(/\s+/g, '');
  }
}
